const merchandiseCredit = {
  merchandiseCredit: {
    noFile: 'Nessun file selezionato',
    fileName: 'Nome file',
    software_service: 'Assistenza software',
    hardware_product: 'Prodotto hardware',
    sampleFileNameUs: 'Credito sulla merce USA',
    sampleFileNameAu: 'Credito sulla merce AU',
    rowNumber: 'Numero non elaborato',
    errorMessage: 'Messaggio'
  }
};

export default merchandiseCredit;
